
import Mainpage from './mainpage';

function App() {
  return (
    <div className="App">
      <Mainpage/>
      </div> 
  );
}

export default App;
